export default "__VITE_ASSET__BYQ$D_Lw__"